module.exports = __webpack_public_path__ + "img/moneyIcon.f8fb0029.svg";